import { apiV1 } from "api-v2";
import type { AxiosResponse } from "axios";

import type { Company } from "../Company/types";
import type { NewUser, User } from "./types/User.type";
import { SharedProfile } from "../SharedProfile/sharedProfile.type";
import { ApiResponse } from "types/common.types";
import { AuthenticateResponse } from "./context/AuthContextProvider";

export const getAllSharedProfilesForCurrentUser = (): Promise<
	AxiosResponse<ApiResponse<SharedProfile[]>>
> => {
	return apiV1.get<ApiResponse<SharedProfile[]>>("auth/all-shared-profiles");
};

export const getUserProfile = (): Promise<AxiosResponse<User>> => {
	return apiV1.get<User>("auth/user-profile");
};

export const getUserToken = () => {
	return apiV1.get("auth/get-token");
};

export const getUserCompanyProfile = (
	companyId: number
): Promise<AxiosResponse<Company>> => {
	return apiV1.get<Company>(`companies/${companyId}/get-profile`);
};

export const createGuestUserAccount = (
	newUser: NewUser
): Promise<AxiosResponse<AuthenticateResponse>> => {
	return apiV1.post<AuthenticateResponse>("guest/register", newUser);
};
